import { render, staticRenderFns } from "./TireProductSummary.vue?vue&type=template&id=e9295d60"
import script from "./TireProductSummary.vue?vue&type=script&lang=ts"
export * from "./TireProductSummary.vue?vue&type=script&lang=ts"
import style0 from "./TireProductSummary.vue?vue&type=style&index=0&id=e9295d60&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports